import { render, staticRenderFns } from "./PortalSection.vue?vue&type=template&id=10290bb4&scoped=true"
import script from "./PortalSection.vue?vue&type=script&lang=js"
export * from "./PortalSection.vue?vue&type=script&lang=js"
import style0 from "./PortalSection.vue?vue&type=style&index=0&id=10290bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10290bb4",
  null
  
)

export default component.exports